import React from 'react'
import { useValues } from 'kea'

import LessonReview from '~/scenes/shared/lesson-review'

import railsContext from 'lib/selectors/rails-context'
import sceneLogic from '~/scenes/homepage/logic'
import { useSelector } from 'react-redux'

export default function LessonReviews () {
  const { reviews, reviewsTitle } = useValues(sceneLogic)
  const { dpr } = useSelector(railsContext)

  return (
    <div id='homepage-lesson-reviews' style={{ background: '#fff', paddingTop: 45, paddingBottom: 20 }}>
      <div className='grid'>
        <div className='col-1-1'>
          <h2 className='homepage'>{reviewsTitle}</h2>
        </div>
      </div>
      <div className='grid'>
        {reviews.map(review => (
          <div className='col-1-3' key={review.id}>
            <LessonReview dpr={dpr} review={review} />
          </div>
        ))}
      </div>
    </div>
  )
}
